//
import { objectToQueryString } from "../../../helpers/objectToQueryString";
import { API } from "../../api";
async function searchProducts(query) {
    const url = process.env.LETS_TRADE_PRODUCT_URL ?? "";
    const response = await new API().apiGet({
        baseUrl: url,
        endpoint: `v2/product/list${objectToQueryString({
            page: query?.page ?? "1",
            size: query?.size ?? "10",
            ...(query?.search_string ? { search_string: query.search_string } : {}),
        })}`,
    });
    return {
        ...response,
        content: response?.content?.product_list ?? [],
    };
}
export { 
// ISearchProductsRequest,
searchProducts, };
